export default __webpack_public_path__ + "static/media/logo.3b67b531.svg";